import { render } from "./AzioniRiga.vue?vue&type=template&id=2ade130a"
import script from "./AzioniRiga.vue?vue&type=script&lang=js"
export * from "./AzioniRiga.vue?vue&type=script&lang=js"

import "./AzioniRiga.vue?vue&type=style&index=0&id=2ade130a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__